/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { FormElementLayoutDefinition } from '../models/form-element-layout-definition';
export interface FormSectionLayoutDefinition {
  customContent?: string | null;
  elementLayoutDefinitions?: Array<FormElementLayoutDefinition> | null;
  guidanceText?: string | null;
  isCollapsed?: boolean | null;
  isHidden?: boolean | null;
  label?: string | null;
  name: string;
}

export class FormSectionLayoutDefinition {
  customContent?: string | null;
  elementLayoutDefinitions?: FormElementLayoutDefinition[] | null;
  guidanceText?: string | null;
  isCollapsed?: boolean | null;
  isHidden?: boolean | null;
  label?: string | null;
  name: string;

  constructor(value: FormSectionLayoutDefinition) {
    this.customContent = value?.customContent;
    this.elementLayoutDefinitions = value?.elementLayoutDefinitions?.map((x) => new FormElementLayoutDefinition(x));
    this.guidanceText = value?.guidanceText;
    this.isCollapsed = value?.isCollapsed;
    this.isHidden = value?.isHidden;
    this.label = value?.label;
    this.name = value.name;
  }
}
